var map = {
	"./xuanxing_banner.jpg": "a4f9",
	"./xuanxing_banner_en.jpg": "8d40",
	"./xuanxing_banner_es.jpg": "1e16",
	"./xuanxing_banner_hk.jpg": "798a",
	"./xuanxing_banner_pt.jpg": "35c8",
	"./xuanxing_banner_tr.jpg": "c67d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ab7c";